import * as React from "react";
const styles = require("./style.less");

interface NothingToSeeHereProps {
    content: string;
}

export class NothingToSeeHere extends React.Component<NothingToSeeHereProps> {
    render() {
        return <p className={styles.content}>{this.props.content}</p>;
    }
}
